import React from 'react'
import type { Icon } from 'shared/utils'

const Mail = (props: Icon) => {
    const { color = 'black', size = 24, className = 'map' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24">
            <path d="M2 8.755V6.4C2 5.075 3.12 4 4.5 4h15C20.88 4 22 5.075 22 6.4v11.2c0 1.325-1.12 2.4-2.5 2.4h-15C3.12 20 2 18.925 2 17.6V8.755zM3.667 9.99v7.61c0 .441.373.8.833.8h15c.46 0 .833-.359.833-.8V9.989l-6.588 2.92a4.33 4.33 0 0 1-3.49-.001l-6.588-2.92zm0-1.763l7.285 3.229a2.6 2.6 0 0 0 2.095 0l7.286-3.229V6.4c0-.441-.373-.8-.833-.8h-15c-.46 0-.833.359-.833.8v1.826z" />
        </svg>
    )
}

export { Mail }
